import type { BrandKit } from "@redotech/redo-content-builder-common/brand-kit";
import type { OrderLookupSettings } from "@redotech/redo-order-tracking-lookup-common/order-lookup-defaults";
import * as z from "zod";

export const getTrackingPageForStorefront = {
  name: "getTrackingPageForStorefront" as const,
  input: z.object({}),
  output: z.object({
    orderLookupSettings: z.custom<OrderLookupSettings>().nullish(),
    brandKit: z.custom<BrandKit>().nullish(),
    widgetSlug: z.string().nullish(),
    loadingBackgroundColor: z.string().nullish(),
  }),
};
